// ==== LANGUAGE DETECTION + TRANSLATIONS =====================================

function getLanguageFromURL() {
    const { hostname, pathname } = location;
    if (hostname.endsWith('.dk') || pathname.startsWith('/dk/')) return 'dk'; // .dk or /dk/
    if (pathname.startsWith('/de')) return 'de';
    return 'en';
  }
  
  const translations = {
    en: {
      // cart
      cart_title: "Your Cart",
      subtotal: "Subtotal",
      checkout_button: "Checkout",
      free_shipping_remaining: "You are {{remaining_amount}} away from FREE SHIPPING!",
      free_shipping_reached: "Congrats! You've unlocked FREE SHIPPING!",
      empty_cart_message: "Your cart is currently empty.",
      empty_cart_cta: "Add your favourite items to your cart",
      empty_cart_button: "Shop Now",
      // results page
      showing_results_for: "Results for “{term}” ({count})",
      search_page_title: "Search results for “{term}”",
      regular_price: "Price",
      sale_price: "Sale price",
      original_price: "Original price",
      view_product: "View {title}",
      add_product_to_cart: "Add {title} to cart",
      filters: "Filter & Sorting",
      products: "Products",
      product_filters: "Product Filters",
      availability: "Availability",
      product_type: "Product Type",
      price: "Price",
      product_tags: "Product Tags",
      vendor: "Vendor",
      sort_by: "Sort by",
      featured: "Featured",
      best_sellers: "Best Sellers",
      highest_price: "Highest Price",
      lowest_price: "Lowest Price",
      new_arrivals: "New Arrivals",
      add_to_cart: "+ Add to cart",
      adding_to_cart: "Adding",
      added_to_cart: "Added",
      sold_out: "Sold Out",
      // quick view
      search_placeholder: "Search products",
      recommended_products: "Recommended Products",
      matching_collections: "Matching collections",
      matching_products: "Matching products",
      see_more: "See more",
      no_results_for: "No Results For",
      // smart collections
      available: "Available",
      from: "From",
      to: "To",
    },
    dk: {
      cart_title: "Din kurv",
      subtotal: "Subtotal",
      checkout_button: "Gå til kassen",
      free_shipping_remaining: "Køb for {{remaining_amount}} mere og få fri fragt til pakkeshop.",
      free_shipping_reached: "Tillykke! Du har fri fragt til pakkeshop!",
      empty_cart_message: "Din kurv er tom.",
      empty_cart_cta: "Tilføj dine yndlingsvarer til din kurv",
      empty_cart_button: "Shop nu",
      // results page
      showing_results_for: "Resultater for “{term}” ({count})",
      search_page_title: "Søgeresultater for “{term}”",
      regular_price: "Pris",
      sale_price: "Tilbudspris",
      original_price: "Førpris",
      view_product: "Se {title}",
      add_product_to_cart: "Tilføj {title} til kurven",
      filters: "Filtre og sortering",
      products: "Produkter",
      product_filters: "Produktfiltre",
      availability: "Tilgængelighed",
      product_type: "Produkttype",
      price: "Pris",
      product_tags: "Produkttags",
      vendor: "Leverandør",
      sort_by: "Sortér efter",
      featured: "Fremhævede",
      best_sellers: "Mest solgte",
      highest_price: "Pris: høj til lav",
      lowest_price: "Pris: lav til høj",
      new_arrivals: "Nyheder",
      add_to_cart: "Tilføj til kurv",
      adding_to_cart: "Tilføjer",
      added_to_cart: "Tilføjet",
      sold_out: "Udsolgt",
      // quick view
      search_placeholder: "Søg efter produkter",
      recommended_products: "Anbefalede produkter",
      matching_collections: "Matchende kollektioner",
      matching_products: "Matchende produkter",
      see_more: "Se mere",
      no_results_for: "Ingen resultater for",
      // smart collections
      available: "På lager",
      from: "Fra",
      to: "Til",
    },
    de: {
      cart_title: "Ihr Warenkorb",
      subtotal: "Zwischensumme",
      checkout_button: "Zur Kasse",
      free_shipping_remaining: "Dir fehlen noch {{remaining_amount}} bis zum KOSTENLOSEN VERSAND!",
      free_shipping_reached: "Glückwunsch! Du hast KOSTENLOSEN VERSAND freigeschaltet!",
      empty_cart_message: "Ihr Warenkorb ist derzeit leer.",
      empty_cart_cta: "Fügen Sie Ihre Lieblingsartikel zu Ihrem Warenkorb hinzu",
      empty_cart_button: "Jetzt einkaufen",
      // results page
      showing_results_for: "Ergebnisse für „{term}“ ({count})",
      search_page_title: "Suchergebnisse für „{term}“",
      regular_price: "Preis",
      sale_price: "Angebotspreis",
      original_price: "Ursprünglicher Preis",
      view_product: "{title} ansehen",
      add_product_to_cart: "{title} in den Warenkorb legen",
      filters: "Filter & Sortierung",
      products: "Produkte",
      product_filters: "Produktfilter",
      availability: "Verfügbarkeit",
      product_type: "Produkttyp",
      price: "Preis",
      product_tags: "Produkt-Tags",
      vendor: "Anbieter",
      sort_by: "Sortieren nach",
      featured: "Empfohlen",
      best_sellers: "Bestseller",
      highest_price: "Höchster Preis",
      lowest_price: "Niedrigster Preis",
      new_arrivals: "Neuankömmlinge",
      add_to_cart: "+ In den Warenkorb",
      adding_to_cart: "Hinzufügen",
      added_to_cart: "Hinzugefügt",
      sold_out: "Ausverkauft",
      // quick view
      search_placeholder: "Suche nach Produkten",
      recommended_products: "Empfohlene Produkte",
      matching_collections: "Passende Kollektionen",
      matching_products: "Passende Produkte",
      see_more: "Mehr sehen",
      no_results_for: "Keine Ergebnisse für",
      // smart collections
      available: "Verfügbar",
      from: "Von",
      to: "Bis", 
    }
  };
  
  const lang = getLanguageFromURL();
  // const lang = 'de'; // testing
  const t = translations[lang] ?? translations.en;
  
  // small helper to replace placeholders inside a string with actual values
  const fmt = (s, map) => s.replace(/\{(\w+)\}/g, (_, k) => (map[k] ?? ''));
  
  // ==== SMART CART =============================================================
  
  let boundSmartCartReady = false;
  if (!boundSmartCartReady) {
    boundSmartCartReady = true;
  
    const translateReadySmartCart = function () {
      const cartTitle = document.querySelector('#rebuy-cart-title');
      if (cartTitle) cartTitle.textContent = t.cart_title;
  
      const subtotalLabel = document.querySelector('.rebuy-cart__flyout-subtotal-label');
      if (subtotalLabel) subtotalLabel.textContent = t.subtotal;
  
      const checkoutButton = document.querySelector('.rebuy-cart__checkout-button');
      if (checkoutButton) checkoutButton.textContent = t.checkout_button;
  
      translateSmartCartProgress();
      observeSmartCartProgress();
      translateEmptyCart();
    };

    document.addEventListener('rebuy:smartcart.ready', translateReadySmartCart);
    if (document.querySelector('#rebuy-cart-title')) {
      translateReadySmartCart();
    }
  
    document.addEventListener('rebuy:cart.change', function () {
      const checkoutButton = document.querySelector('.rebuy-cart__checkout-button');
      if (checkoutButton) checkoutButton.textContent = t.checkout_button;

      // wait for Rebuy to re-render, then translate
      requestAnimationFrame(() => setTimeout(() => {
        translateSmartCartProgress();
        observeSmartCartProgress();
        translateEmptyCart();
      }, 50));
    });
  }

    function translateSmartCartProgress() {
      if (window.Rebuy?.SmartCart?.progressBar?.language) {
        Rebuy.SmartCart.progressBar.language.free_shipping_remaining = t.free_shipping_remaining;
        Rebuy.SmartCart.progressBar.language.free_shipping_reached = t.free_shipping_reached;
      }

      const prompt = document.querySelector('#rebuy-cart__progress-bar-meter-label');
      if (prompt) {
        const currentText = prompt.textContent.trim();
        const remainingMatch = currentText.match(/^You are\s+(.+?)\s+away from FREE SHIPPING!$/i);

        if (remainingMatch) {
          prompt.textContent = t.free_shipping_remaining.replace('{{remaining_amount}}', remainingMatch[1]);
        } else if (/^Congrats! You've unlocked FREE SHIPPING!$/i.test(currentText)) {
          prompt.textContent = t.free_shipping_reached;
        }
      }

      document.querySelectorAll('.rebuy-cart__progress-step-label').forEach((label) => {
        if (lang === 'dk' && /^Free Shipping$/i.test(label.textContent.trim())) {
          label.textContent = 'Fri fragt';
        } else if (lang === 'de' && /^Free Shipping$/i.test(label.textContent.trim())) {
          label.textContent = 'Kostenloser Versand';
        }
      });
    }

    function observeSmartCartProgress() {
      const cart = document.querySelector('#rebuy-cart');

      if (!cart || cart.dataset.eleProgressTranslationObserver === 'true') return;

      cart.dataset.eleProgressTranslationObserver = 'true';

      const observer = new MutationObserver(() => translateSmartCartProgress());
      observer.observe(cart, { childList: true, subtree: true, characterData: true });
      cart.__eleProgressTranslationObserver = observer;
    }

    requestAnimationFrame(() => setTimeout(() => {
      translateSmartCartProgress();
      observeSmartCartProgress();
    }, 50));

    // ==== SMART CART - EMPTY =============================================================


  function translateEmptyCart() {
    const emptyCart = document.querySelector('.rebuy-cart__flyout-empty-cart');
    if (!emptyCart) return;
  
    // <h4> title
    const title = emptyCart.querySelector('h4');
    if (title && t.empty_cart_message) {
      title.textContent = t.empty_cart_message;
    }
  
    // message <p> (the one without the link to collections)
    const paragraphs = emptyCart.querySelectorAll('p.ql-align-center');
    const messageP = Array.from(paragraphs).find(p => !p.querySelector('a'));
    if (messageP && t.empty_cart_cta) {
      messageP.textContent = t.empty_cart_cta;
    }
  
    // button text (the <a> inside the other <p>)
    const buttonLink = emptyCart.querySelector('p.ql-align-center a');
    if (buttonLink && t.empty_cart_button) {
      buttonLink.textContent = t.empty_cart_button;
      buttonLink.style.backgroundColor = "rgba(21, 21, 21, 1)";
      buttonLink.style.borderColor = "transparent";
      buttonLink.style.border = "none";
      buttonLink.style.borderWidth = "0";
    }
  }
  
  // ==== SMART SEARCH – RESULTS PAGE ===========================================
  
  function translateSmartSearch(instance) {
    const urlParams = new URLSearchParams(window.location.search);
    const term = urlParams.get('q') || '';
  
    const titleEl = document.querySelector('.rebuy-smart-search-results-page-sidebar-flyout__result-title');
    if (titleEl) {
        // Extract count from instance OR from current text
        let count = instance?.state?.resultsCount ?? instance?.payload?.resultsCount ?? '';
        
        if (!count) {
            const countMatch = titleEl.textContent.match(/\((\d+)\)/);
            count = countMatch ? countMatch[1] : '';
        }
        
        const next = fmt(t.showing_results_for, { term, count });
        if (titleEl.textContent.trim() !== next.trim()) {
            titleEl.textContent = next;
        }
    }
  
    const filtersH3 = document.querySelector('.rebuy-smart-search-results-page-sidebar-flyout__filter-mobile-facets-label');
    if (filtersH3 && filtersH3.textContent.trim() !== t.filters) {
      filtersH3.textContent = t.filters;
    }
  
    const productsH3 = document.querySelector('.rebuy-smart-search-results-page-sidebar-flyout__result-section-title');
    if (productsH3) productsH3.style.display = 'none';
  
    const productFiltersButton = document.querySelector('button.filter-title.rebuy-button');
    if (productFiltersButton) {
      const productFiltersP = productFiltersButton.querySelector('p');
      if (productFiltersP) {
        const icon = productFiltersP.querySelector('i');
        productFiltersP.textContent = t.product_filters + ' ';
        if (icon) productFiltersP.appendChild(icon);
      }
  
      const currentAriaLabel = productFiltersButton.getAttribute('aria-label');
      if (currentAriaLabel && !currentAriaLabel.includes(t.product_filters)) {
        const verbMap = {
          en: { open: 'Open', close: 'Close' },
          dk: { open: 'Åbn', close: 'Luk' },
          de: { open: 'Öffnen', close: 'Schließen' }
        };
        const verbs = verbMap[lang] ?? verbMap.en;
        const isClose = /close|luk|schließ/i.test(currentAriaLabel);
        productFiltersButton.setAttribute('aria-label', `${isClose ? verbs.close : verbs.open} ${t.product_filters.toLowerCase()} dropdown`);
      }
    }
  
    translateSortDropdown();
    setTimeout(translateSortDropdown, 100);
  
    translateAddToCartButtons();
    translateSearchResultContent();
}
  
function translateSearchResultContent() {
    const resultsRoot = document.querySelector('.rebuy-smart-search-results-page__main-section');
    if (!resultsRoot) return;

    resultsRoot.querySelectorAll('.rebuy-smart-search-results-page__product').forEach(card => {
      const titleLink = card.querySelector('.rebuy-product-title');
      const title = (titleLink?.textContent || '').trim();
      if (!title) return;

      const image = card.querySelector('img.rebuy-smart-search-results-page__product-image');
      if (image && image.getAttribute('alt') !== title) image.setAttribute('alt', title);

      const mediaLink = card.querySelector('a.rebuy-product-media');
      if (mediaLink) {
        mediaLink.removeAttribute('alt');
        mediaLink.setAttribute('aria-label', fmt(t.view_product, { title }));
      }

      if (titleLink) titleLink.removeAttribute('alt');

      card.querySelectorAll('.rebuy-money .sr-only').forEach(label => {
        const price = label.closest('.rebuy-money');
        const next = price?.classList.contains('sale')
          ? t.sale_price
          : price?.classList.contains('compare-at')
            ? t.original_price
            : t.regular_price;
        if (next && label.textContent.trim() !== next) label.textContent = next;
      });

      const cartButton = card.querySelector('button.rebuy-smart-search-results-page__cta');
      if (cartButton) {
        cartButton.setAttribute('aria-label', fmt(t.add_product_to_cart, { title }));
        const label = cartButton.querySelector('span');
        const current = (label?.textContent || '').trim().toLowerCase();

        if (label) {
          if (/sold out|udsolgt|ausverkauft/.test(current)) label.textContent = t.sold_out;
          else if (/adding|tilføjer|hinzufüg/.test(current)) label.textContent = t.adding_to_cart;
          else if (/added|tilføjet|hinzugefügt/.test(current)) label.textContent = t.added_to_cart;
          else label.textContent = t.add_to_cart;
        }
      }
    });

    const filtersButton = document.querySelector('.rebuy-smart-search-results-page-sidebar-flyout__filter-mobile-facets');
    if (filtersButton) filtersButton.setAttribute('aria-label', t.filters);

    const term = new URLSearchParams(window.location.search).get('q') || '';
    if (term && t.search_page_title) {
      document.title = fmt(t.search_page_title, { term }) + ' | élé living';
    }
  }

  let __rebuySSRInstance = null;

document.addEventListener('rebuy:smartsearch.resultsPage.ready', (e) => {
    __rebuySSRInstance = e.detail?.smartSearchResultsPage || null;
    setTimeout(() => translateSmartSearch(__rebuySSRInstance), 600);
    setTimeout(() => translateSmartSearch(__rebuySSRInstance), 700);
    setTimeout(() => translateSmartSearch(__rebuySSRInstance), 800);
    setTimeout(() => translateSmartSearch(__rebuySSRInstance), 900);
    watchAddToCartButtons();
});

document.addEventListener('rebuy:smartsearch.resultsPage.change', (e) => {
    __rebuySSRInstance = e.detail?.smartSearchResultsPage || __rebuySSRInstance;
    setTimeout(() => translateSmartSearch(__rebuySSRInstance), 600);
    setTimeout(() => translateSmartSearch(__rebuySSRInstance), 700);
    setTimeout(() => translateSmartSearch(__rebuySSRInstance), 800);
    setTimeout(() => translateSmartSearch(__rebuySSRInstance), 900);
});
  
  // ==== SMART SEARCH – RESULTS PAGE - SORT DROPDOWN TRANSLATION ===========================================
  
  const sortValueMap = {
    'featured': 'featured',
    'best-sellers': 'best_sellers',
    'highest-price': 'highest_price',
    'lowest-price': 'lowest_price',
    'new-arrivals': 'new_arrivals'
  };
  
  function translateSortDropdown() {
    const sortLabel = document.querySelector('.rebuy-smart-search-results-page-sidebar-flyout__sort-by-label');
    if (sortLabel && sortLabel.textContent.trim() !== t.sort_by) {
      sortLabel.textContent = t.sort_by;
    }
  
    const sortSelect = document.getElementById('rebuy-smart-search-sort-options');
    if (sortSelect) {
      sortSelect.querySelectorAll('option').forEach(option => {
        const key = sortValueMap[option.value];
        if (key && t[key] && option.textContent.trim() !== t[key]) {
          option.textContent = t[key];
        }
      });
    }
  }
  
  let sortObserver = null;
  function watchForSortDropdown() {
    if (sortObserver) return;
    sortObserver = new MutationObserver(() => {
      if (document.getElementById('rebuy-smart-search-sort-options')) {
        translateSortDropdown();
      }
    });
    sortObserver.observe(document.body, { childList: true, subtree: true });
  }
  watchForSortDropdown();
  
 // ==== SMART SEARCH – RESULTS PAGE - FILTER FLYOUT TRANSLATION =================

const filterKeywordMap = {
    'availability': 'availability',
    'tilgængelighed': 'availability',
    'verfügbarkeit': 'availability',
    'product type': 'product_type',
    'produkttype': 'product_type',
    'produkttyp': 'product_type',
    'price': 'price',
    'pris': 'price',
    'preis': 'price',
    'product tags': 'product_tags',
    'produkt tags': 'product_tags',
    'produkt-tags': 'product_tags',
    'vendor': 'vendor',
    'leverandør': 'vendor',
    'anbieter': 'vendor'
  };
  
  function translateFilterFlyoutOnce() {
    const flyout = document.getElementById('rebuy-smart-search-results-filter-flyout');
    if (!flyout) return false;

    // change dollar sign to kroner sign in price filter if lang is 'dk'. Otherwise to euro
    const filterDrawerdollarSigns = flyout.querySelectorAll('.rebuy-smart-search-results-page__filter-price-block .rebuy-smart-search-results-page__filter-price-label');
    filterDrawerdollarSigns.forEach(el => {
    if (lang === 'dk') {
        el.textContent = el.textContent.replace('$', 'kr ');
    } else {
        el.textContent = el.textContent.replace('$', '€ ');
    }
    }); 
  
    const buttons = flyout.querySelectorAll('button.rebuy-smart-search-results-page-sidebar-flyout__filter-list-toggle');
    if (!buttons.length) return false;
  
    buttons.forEach(btn => {
      const h4 = btn.querySelector('.rebuy-smart-search-results-page-sidebar-flyout__filter-list-title');
      if (!h4) return;
  
      // use aria-label, fallback to visible title
      const ariaLabel = ((btn.getAttribute('aria-label') || btn.getAttribute('alt') || h4.textContent) || '').toLowerCase();
  
      let key = null;
      for (const [keyword, translationKey] of Object.entries(filterKeywordMap)) {
        if (ariaLabel.includes(keyword)) { key = translationKey; break; }
      }
      if (!key || !t[key]) return;
  
      const current = (h4.textContent || '').trim();
      if (current !== t[key]) h4.textContent = t[key];
  
      ['aria-label', 'alt'].forEach(attr => {
        const val = btn.getAttribute(attr);
        if (!val) return;
        const isClose = /^(Close|Luk|Schließen)/i.test(val);
        const verbs = {
          en: { open: 'Open', close: 'Close' },
          dk: { open: 'Åbn', close: 'Luk' },
          de: { open: 'Öffnen', close: 'Schließen' }
        }[lang] ?? { open: 'Open', close: 'Close' };
        const newValue = `${isClose ? verbs.close : verbs.open} ${t[key]}`;
        if (newValue !== val) btn.setAttribute(attr, newValue);
      });
    });
  
    return true;
  }
  
  let filterFlyoutObserver = null;
  function startWatchingForFilterFlyout() {
    if (filterFlyoutObserver) return;
  
    // run now (works even if aria-hidden="true")
    translateFilterFlyoutOnce();
    requestAnimationFrame(translateFilterFlyoutOnce);
    setTimeout(translateFilterFlyoutOnce, 100);
  
    filterFlyoutObserver = new MutationObserver(muts => {
      let shouldRun = false;
  
      for (const m of muts) {
        if (m.type === 'childList') {
          if ([...(m.addedNodes || [])].some(n =>
            n.nodeType === 1 &&
            (n.matches?.('#rebuy-smart-search-results-filter-flyout, .rebuy-smart-search-results-page__flyout-inner') ||
             n.querySelector?.('button.rebuy-smart-search-results-page-sidebar-flyout__filter-list-toggle'))
          )) {
            shouldRun = true;
          }
        }
        if (m.type === 'attributes' && m.attributeName === 'aria-hidden' && m.target?.id === 'rebuy-smart-search-results-filter-flyout') {
          shouldRun = true;
        }
      }
  
      if (shouldRun) {
        translateFilterFlyoutOnce();
        requestAnimationFrame(translateFilterFlyoutOnce);
        setTimeout(translateFilterFlyoutOnce, 120);
      }
    });
  
    // watch body until flyout appears, then its subtree
    filterFlyoutObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startWatchingForFilterFlyout, { once: true });
  } else {
    startWatchingForFilterFlyout();
  }
  
  document.addEventListener('click', (ev) => {
    if (
      ev.target.closest('[aria-controls="rebuy-smart-search-results-filter-flyout"]') ||
      ev.target.closest('.rebuy-smart-search-results-page__flyout-close')
    ) {
      setTimeout(translateFilterFlyoutOnce, 50);
      requestAnimationFrame(translateFilterFlyoutOnce);
      setTimeout(translateFilterFlyoutOnce, 150);
    }
  });
  
  let titleObserver = null;
  function watchAndTranslateTitleElement() {
    const titleEl = document.querySelector('.rebuy-smart-search-results-page-dropdown__result-title');
    if (!titleEl) return void setTimeout(watchAndTranslateTitleElement, 100);
    if (titleObserver) return;
  
    titleObserver = new MutationObserver(() => {
      const urlParams = new URLSearchParams(window.location.search);
      const term = urlParams.get('q') || '';
      const currentText = titleEl.textContent || '';
      const countMatch = currentText.match(/\((\d+)\)/);
      const count = countMatch ? countMatch[1] : (__rebuySSRInstance?.state?.resultsCount ?? __rebuySSRInstance?.payload?.resultsCount ?? '');
      const next = fmt(t.showing_results_for, { term, count });
      if (titleEl.textContent !== next) titleEl.textContent = next;
    });
  
    titleObserver.observe(titleEl, { childList: true, characterData: true, subtree: true });
  }
  
  document.addEventListener('rebuy:smartsearch.resultsPage.ready', () => {
    watchAndTranslateTitleElement();
  });

  // ==== SMART SEARCH – RESULTS PAGE - ADD TO CART BUTTONS ===========================================
  
  function translateAddToCartButtons() {
    document.querySelectorAll('button.rebuy-smart-search-results-page__cta').forEach(btn => {
      btn.style.backgroundColor = "rgba(21, 21, 21, 1)"; // custom style fix
      btn.style.marginTop = "15px"; // custom style fix
      const span = btn.querySelector('span');
      if (!span) return;
      const currentText = span.textContent.trim().toLowerCase();
      let key = null;
      if (['add', 'tilføj', 'føj til kurv', 'tilføj til kurv', 'hinzufügen'].includes(currentText)) key = 'add_to_cart';
      else if (['added', 'tilføjet', 'hinzugefügt'].includes(currentText)) key = 'added_to_cart';
      else if (['sold out', 'udsolgt', 'ausverkauft'].includes(currentText)) key = 'sold_out';
      if (key && t[key] && span.textContent.trim() !== t[key]) span.textContent = t[key];
    });
  }
  
  let addToCartObserver = null;
  function watchAddToCartButtons() {
    if (addToCartObserver) return;
    const resultsContainer = document.querySelector('.rebuy-smart-search-results-page__main-section');
    if (!resultsContainer) return;
    addToCartObserver = new MutationObserver(() => {
      translateAddToCartButtons();
      translateSearchResultContent();
    });
    addToCartObserver.observe(resultsContainer, { childList: true, subtree: true, characterData: true });
  }
  
  // ==== SMART SEARCH – QUICK VIEW =================================
  
  // --- debounce utility with cancel ---
  function debounce(fn, wait) {
    let timeout;
    function debounced(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn(...args), wait);
    }
    debounced.cancel = () => clearTimeout(timeout);
    return debounced;
  }
  
  // Debounced translators (defined once)
  const debouncedTranslateMatchingTitles = debounce(translateQuickViewMatchingTitles, 120);
  const debouncedTranslateNoResults     = debounce(translateNoResultsMessage, 120);
  const debouncedTranslateAddToCart     = debounce(translateQuickViewAddToCartButtons, 120);
  
  function translateSmartSearchQuickView() {
    const searchInput = document.getElementById('searchInput');
    if (searchInput) {
      const currentPlaceholder = searchInput.getAttribute('placeholder');
      if (currentPlaceholder && currentPlaceholder !== t.search_placeholder) {
        searchInput.setAttribute('placeholder', t.search_placeholder);
      }
    }
  
    const searchLabel = document.querySelector('label[for="searchInput"]');
    if (searchLabel && searchLabel.textContent.trim() !== t.search_placeholder) {
      searchLabel.textContent = t.search_placeholder;
    }
  
    const recommendedTitle = document.querySelector('.rebuy-quick-view__title.rebuy-quick-view-dropdown__title');
    if (recommendedTitle && recommendedTitle.textContent.trim() !== t.recommended_products) {
      recommendedTitle.textContent = t.recommended_products;
    }
  
    translateQuickViewAddToCartButtons();
  }

  // ==== SMART SEARCH – QUICK VIEW - ADD TO CART BUTTONS ===========================================
  function translateQuickViewAddToCartButtons() {
    document.querySelectorAll('button.rebuy-quick-view__product-cta').forEach(btn => {
      btn.style.backgroundColor = "rgba(21, 21, 21, 1)"; // custom style fix
      btn.style.marginTop = "15px"; // custom style fix
      const span = btn.querySelector('span');
      if (!span) return;
      const currentText = span.textContent.trim().toLowerCase();
      let key = null;
      if (['add', 'tilføj', 'hinzufügen'].includes(currentText)) key = 'add_to_cart';
      else if (['added', 'tilføjet', 'hinzugefügt'].includes(currentText)) key = 'added_to_cart';
      else if (['sold out', 'udsolgt', 'ausverkauft'].includes(currentText)) key = 'sold_out';
      if (key && t[key] && span.textContent.trim() !== t[key]) span.textContent = t[key];
    });
  }
  
  // ==== SMART SEARCH – QUICK VIEW - TRANSLATED TITLES ==========================================
  function translateQuickViewMatchingTitles() {
    const collectionsTitle = document.querySelector('.rebuy-quick-view__collection-section .rebuy-quick-view__title');
    const collectionsSeeMoreButton = document.querySelector('.rebuy-quick-view__collection-list button.see-more');
    if (collectionsTitle && collectionsTitle.textContent.trim() !== t.matching_collections) {
      collectionsTitle.textContent = t.matching_collections;
      if (collectionsSeeMoreButton) collectionsSeeMoreButton.textContent = t.see_more;
    }
  
    const suggestedProductsTitle = document.querySelector('.rebuy-quick-view__suggestions .rebuy-quick-view__product-section .rebuy-quick-view__title');
    if (suggestedProductsTitle && suggestedProductsTitle.textContent.trim() !== t.recommended_products) {
      suggestedProductsTitle.textContent = t.recommended_products;
    }

    // add space away from collections
    const matchingProductsSection = document.querySelector('.rebuy-quick-view-dropdown__results .rebuy-quick-view__product-section');
    if (matchingProductsSection) {
      matchingProductsSection.style.marginTop = '20px';
    }

    const matchingProductsTitle = document.querySelector('.rebuy-quick-view-dropdown__results .rebuy-quick-view__product-section .rebuy-quick-view__title');
    if (matchingProductsTitle && matchingProductsTitle.textContent.trim() !== t.matching_products) {
      matchingProductsTitle.textContent = t.matching_products;
    }
  }
  
  function translateNoResultsMessage() {
    const resultsContainer = document.querySelector('.rebuy-quick-view-dropdown__results');
    if (!resultsContainer) return;
    const noResultsDiv = resultsContainer.querySelector('.rebuy-quick-view__no-results');
    if (!noResultsDiv) return;
    const noResultsP = noResultsDiv.querySelector('p');
    if (!noResultsP) return;
    if (noResultsP.getAttribute('data-translated') === 'true') return;
  
    const span = noResultsP.querySelector('span');
  
    noResultsP.innerHTML = '';
    noResultsP.textContent = t.no_results_for + ' [';
    noResultsP.style.fontWeight = '500';
    noResultsP.style.fontSize = '12px';
    if (span) noResultsP.appendChild(span);
    noResultsP.appendChild(document.createTextNode(']'));
    noResultsP.setAttribute('data-translated', 'true');
  }
  
  let quickViewObserver = null;
  function watchForQuickView() {
    if (quickViewObserver) return;
  
    const quickViewContainer = document.querySelector('.rebuy-quick-view-dropdown__container');
    if (!quickViewContainer) {
      setTimeout(watchForQuickView, 500);
      return;
    }
  
    let hasTranslatedOnce = false;
  
    quickViewObserver = new MutationObserver(() => {
      const visible = quickViewContainer.classList.contains('visible');
  
      if (visible) {
        // First-time fast pass on open
        if (!hasTranslatedOnce) {
          translateSmartSearchQuickView();
          translateQuickViewAddToCartButtons();
          translateQuickViewMatchingTitles();
  
          // Single delayed pass to catch late content
          setTimeout(() => {
            translateQuickViewMatchingTitles();
            translateNoResultsMessage();
          }, 400);
  
          hasTranslatedOnce = true;
        }
  
        // Debounced follow-up work while visible
        debouncedTranslateMatchingTitles();
        debouncedTranslateAddToCart();
  
        const resultsContainer = document.querySelector('.rebuy-quick-view-dropdown__results');
        if (resultsContainer && resultsContainer.querySelector('.rebuy-quick-view__no-results')) {
          debouncedTranslateNoResults();
        }
      } else {
        // Reset when closed and cancel pending calls
        hasTranslatedOnce = false;
        debouncedTranslateMatchingTitles.cancel();
        debouncedTranslateAddToCart.cancel();
        debouncedTranslateNoResults.cancel();
      }
    });
  
    quickViewObserver.observe(quickViewContainer, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true,
      characterData: true // text-only changes also trigger
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchForQuickView, { once: true });
  } else {
    watchForQuickView();
  }
  
  document.addEventListener('rebuy:smartsearch.ready', () => {
    translateSmartSearchQuickView();
  });

// ==== SMART COLLECTIONS – SIDEBAR ============================================

function translateSmartCollectionsSidebar() {
    const container = document.querySelector('.rebuy-smart-collections-sidebar__main-section');
    if (!container) return;
  
    // Top "Filters" title
    const filtersH3 = container.querySelector('.rebuy-smart-collections-sidebar__filter-section-title.rebuy-title');
    if (filtersH3 && t.filters && filtersH3.textContent.trim() !== t.filters) {
      filtersH3.textContent = t.filters;
      filtersH3.style.marginBottom = "20px";
    }

    // filter & sort span mobile
    const filterSortSpan = container.querySelector('.rebuy-smart-collections-sidebar__filter-mobile-facets-label');
    if (filterSortSpan && t.filters && filterSortSpan.textContent.trim() !== t.filters) {
      filterSortSpan.textContent = t.filters;
    }
  
    // Section titles + aria-labels: Availability, Product Type, Price, Product Tags, Vendor
    const sectionToggles = container.querySelectorAll('.rebuy-smart-collections-sidebar__filter-list-toggle');
    sectionToggles.forEach(btn => {
      const h4 = btn.querySelector('.rebuy-smart-collections-sidebar__filter-list-title');
      if (!h4) return;
  
      const aria = (btn.getAttribute('aria-label') || btn.getAttribute('alt') || '').toLowerCase();
      const title = (h4.textContent || '').toLowerCase();
  
      // Which key is this section?
      const entries = Object.entries({
        availability: 'availability',
        'tilgængelighed': 'availability',
        'verfügbarkeit': 'availability',
        'product type': 'product_type',
        produkttype: 'product_type',
        produkttyp: 'product_type',
        price: 'price',
        pris: 'price',
        preis: 'price',
        'product tags': 'product_tags',
        'produkt tags': 'product_tags',
        'produkt-tags': 'product_tags',
        vendor: 'vendor',
        leverandør: 'vendor',
        anbieter: 'vendor'
      });
  
      let key = null;
      for (const [needle, k] of entries) {
        if (aria.includes(needle) || title.includes(needle)) { key = k; break; }
      }
      if (!key || !t[key]) return;
  
      // Title text
      if (h4.textContent.trim() !== t[key]) h4.textContent = t[key];
  
      // Aria: "Open/Close {Section}"
      const verbMap = {
        en: { open: 'Open', close: 'Close' },
        dk: { open: 'Åbn', close: 'Luk' },
        de: { open: 'Öffnen', close: 'Schließen' }
      };
      const verbs = verbMap[lang] ?? verbMap.en;
      ['aria-label', 'alt'].forEach(attr => {
        const val = btn.getAttribute(attr);
        if (!val) return;
        const isClose = /close|luk|schließ/i.test(val);
        const localized = `${isClose ? verbs.close : verbs.open} ${t[key]}`;
        if (val !== localized) btn.setAttribute(attr, localized);
      });
    });
  
    // Price placeholders: "From" / "To"
    const priceBlock = container.querySelector('.rebuy-smart-collections__filter-price');
    if (priceBlock) {
      const fromInput = priceBlock.querySelector('#rebuy-option-price-from');
      const toInput   = priceBlock.querySelector('#rebuy-option-price-to');
  
      if (fromInput && t.from && fromInput.getAttribute('placeholder') !== t.from) {
        fromInput.setAttribute('placeholder', t.from);
      }
      if (toInput && t.to && toInput.getAttribute('placeholder') !== t.to) {
        toInput.setAttribute('placeholder', t.to);
      }

    // change dollar sign to kroner sign in price filter if lang is 'dk'. Otherwise to euro
    const filterDrawerdollarSigns = priceBlock.querySelectorAll('.rebuy-smart-collections__filter-price-label');
    filterDrawerdollarSigns.forEach(el => {
      if (lang === 'dk') {
          el.textContent = el.textContent.replace('$', 'kr ');
      } else {
          el.textContent = el.textContent.replace('$', '€ ');
      }
    }); 
    }
  }
  
  // Debounced watcher
  let smartCollectionsObserver = null;
  const debouncedTranslateSmartCollections = debounce(translateSmartCollectionsSidebar, 120);
  
  function watchSmartCollectionsSidebar() {
    // Try later if not mounted yet
    if (!document.querySelector('.rebuy-smart-collections-sidebar__main-section')) {
      setTimeout(watchSmartCollectionsSidebar, 300);
      return;
    }
  
    // Initial translation
    translateSmartCollectionsSidebar();
  
    // Observe sidebar for dynamic updates
    if (smartCollectionsObserver) return;
    const container = document.querySelector('.rebuy-smart-collections-sidebar__main-section');
    smartCollectionsObserver = new MutationObserver(() => {
      debouncedTranslateSmartCollections();
    });
    smartCollectionsObserver.observe(container, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchSmartCollectionsSidebar, { once: true });
  } else {
    watchSmartCollectionsSidebar();
  }

  // ==== SMART COLLECTIONS – MOBILE FLYOUT FILTER LABELS ONLY ===================

const scFilterKeywordMap = {
    'availability': 'availability',
    'tilgængelighed': 'availability',
    'verfügbarkeit': 'availability',
  
    'product type': 'product_type',
    'produkttype': 'product_type',
    'produkttyp': 'product_type',
  
    'price': 'price',
    'pris': 'price',
    'preis': 'price',
  
    'product tags': 'product_tags',
    'produkt tags': 'product_tags',
    'produkt-tags': 'product_tags',
  
    'vendor': 'vendor',
    'leverandør': 'vendor',
    'anbieter': 'vendor'
  };
  
  function verbsFor(lang) {
    return (
      { en:{open:'Open', close:'Close'}, dk:{open:'Åbn', close:'Luk'}, de:{open:'Öffnen', close:'Schließen'} }[lang]
      || { open:'Open', close:'Close' }
    );
  }
  
  function translateCollectionsFlyoutOnce() {
    const flyout = document.querySelector('.rebuy-smart-collections__flyout');
    if (!flyout) return false;

    // change dollar sign to kroner sign in price filter if lang is 'dk'. Otherwise to euro
    const filterDrawerdollarSigns = document.querySelectorAll('.rebuy-smart-collections-sidebar__filter-container .rebuy-smart-collections__filter-price-label');
    filterDrawerdollarSigns.forEach(el => {
      if (lang === 'dk') {
          el.textContent = el.textContent.replace('$', 'kr ');
      } else {
          el.textContent = el.textContent.replace('$', '€ ');
      }
    });

    // "Sort By" label inside drawer
    const sortLabel = flyout.querySelector('.rebuy-smart-collections-sidebar__sort-by-label');
    if (sortLabel && t.sort_by && sortLabel.textContent.trim() !== t.sort_by) {
        sortLabel.textContent = t.sort_by;
    }
  
    // buttons inside the flyout on mobile (same class as desktop)
    const toggles = flyout.querySelectorAll('.rebuy-smart-collections-sidebar__filter-list-toggle');
    if (!toggles.length) return false;
  
    toggles.forEach(btn => {
      const h4 = btn.querySelector('.rebuy-smart-collections-sidebar__filter-list-title');
      if (!h4) return;
  
      // detect which section using aria or current title
      const base = ((btn.getAttribute('aria-label') || btn.getAttribute('alt') || h4.textContent) || '').toLowerCase();
  
      let key = null;
      for (const [needle, k] of Object.entries(scFilterKeywordMap)) {
        if (base.includes(needle)) { key = k; break; }
      }
      if (!key || !t[key]) return;
  
      // set visible title
      const wanted = t[key];
      if ((h4.textContent || '').trim() !== wanted) h4.textContent = wanted;
  
      // localize aria
      const v = verbsFor(lang);
      ['aria-label','alt'].forEach(attr => {
        const val = btn.getAttribute(attr);
        if (!val) return;
        const isClose = /^(close|luk|schließ)/i.test(val);
        const localized = `${isClose ? v.close : v.open} ${wanted}`;
        if (val !== localized) btn.setAttribute(attr, localized);
      });
    });
  
    return true;
  }
  
  // Watch just the flyout: re-run when it mounts, updates, or toggles `is-visible`
  let scFlyoutObserver = null;
  function watchCollectionsFlyout() {
    if (scFlyoutObserver) return;
    // initial run
    translateCollectionsFlyoutOnce();
    requestAnimationFrame(translateCollectionsFlyoutOnce);
    setTimeout(translateCollectionsFlyoutOnce, 80);
  
    const root = document.body; // flyout may be portal-mounted later
    scFlyoutObserver = new MutationObserver(muts => {
      let rerun = false;
      for (const m of muts) {
        if (m.type === 'childList') {
          // flyout added/inner content swapped
          if ([...(m.addedNodes||[])].some(n =>
            n.nodeType === 1 && (n.matches?.('.rebuy-smart-collections__flyout') ||
            n.querySelector?.('.rebuy-smart-collections__flyout'))
          )) rerun = true;
          if ([...(m.addedNodes||[])].some(n =>
            n.nodeType === 1 && n.querySelector?.('.rebuy-smart-collections-sidebar__filter-list-toggle')
          )) rerun = true;
        }
        if (m.type === 'attributes' && m.attributeName === 'class') {
          const tgt = m.target;
          if (tgt instanceof Element && tgt.matches('.rebuy-smart-collections__flyout')) {
            // is-visible toggled
            rerun = true;
          }
        }
      }
      if (rerun) {
        translateCollectionsFlyoutOnce();
        requestAnimationFrame(translateCollectionsFlyoutOnce);
        setTimeout(translateCollectionsFlyoutOnce, 120);
      }
    });
  
    scFlyoutObserver.observe(root, { childList:true, subtree:true, attributes:true, attributeFilter:['class'] });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchCollectionsFlyout, { once:true });
  } else {
    watchCollectionsFlyout();
  }

  // ==== SMART COLLECTIONS – SORTING ===========================================

function translateSmartCollectionsSorting() {
    const container = document.querySelector('.rebuy-smart-collections__container');
    if (!container) return;
  
    // Translate "Sort By" label
    const sortLabel = container.querySelector('.rebuy-smart-collections-sidebar__sort-by-label');
    if (sortLabel && t.sort_by && sortLabel.textContent.trim() !== t.sort_by) {
      sortLabel.textContent = t.sort_by;
    }
  
    // Translate sort dropdown options
    const select = container.querySelector('#rebuy-smart-collections-sort-options');
    if (!select) return;
  
    const optionMap = {
      'featured': 'featured',
      'best-sellers': 'best_sellers',
      'highest-price': 'highest_price',
      'lowest-price': 'lowest_price',
      'new-arrivals': 'new_arrivals'
    };
  
    select.querySelectorAll('option').forEach(option => {
      const key = optionMap[option.value];
      if (key && t[key] && option.textContent.trim() !== t[key]) {
        option.textContent = t[key];
      }
    });
  }
  
  // Debounced watcher for sorting
  let smartCollectionsSortObserver = null;
  const debouncedTranslateCollectionsSorting = debounce(translateSmartCollectionsSorting, 120);
  
  function watchSmartCollectionsSorting() {
    const container = document.querySelector('.rebuy-smart-collections__container');
    if (!container) {
      setTimeout(watchSmartCollectionsSorting, 300);
      return;
    }
  
    // Initial load
    translateSmartCollectionsSorting();
  
    // Observe changes
    if (smartCollectionsSortObserver) return;
    smartCollectionsSortObserver = new MutationObserver(() => {
      debouncedTranslateCollectionsSorting();
    });
  
    smartCollectionsSortObserver.observe(container, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
  
  // Start watching
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchSmartCollectionsSorting, { once: true });
  } else {
    watchSmartCollectionsSorting();
  }

  // ==== SMART COLLECTIONS – ADD TO CART BUTTONS ================================

function translateSmartCollectionsAddToCart() {
    document.querySelectorAll('button.rebuy-smart-collections__cta').forEach(btn => {
      btn.style.backgroundColor = "rgba(31, 31, 31, 1)";
  
      const span = btn.querySelector('span');
      if (!span) return;
  
      const currentText = span.textContent.trim().toLowerCase();
  
      let key = null;
      if (['add to cart', 'add', 'tilføj', 'in den warenkorb', 'hinzufügen'].includes(currentText)) {
        key = 'add_to_cart';
      } else if (['adding', 'tilføjer', 'fügt hinzu'].includes(currentText)) {
        key = 'adding_to_cart';
      } else if (['added', 'tilføjet', 'hinzugefügt'].includes(currentText)) {
        key = 'added_to_cart';
      } else if (['sold out', 'udsolgt', 'ausverkauft'].includes(currentText)) {
        key = 'sold_out';
      }
  
      if (key && t[key] && span.textContent.trim() !== t[key]) {
        span.textContent = t[key];
      }
    });
  }
  
  // Observer to detect rerender of product cards
  let smartCollectionsAddToCartObserver = null;
  function watchSmartCollectionsAddToCart() {
    const container = document.querySelector('.rebuy-smart-collections__container');
    if (!container) {
      setTimeout(watchSmartCollectionsAddToCart, 300);
      return;
    }
  
    // Translate immediately on page load
    translateSmartCollectionsAddToCart();
  
    if (smartCollectionsAddToCartObserver) return;
  
    smartCollectionsAddToCartObserver = new MutationObserver(() => {
      translateSmartCollectionsAddToCart();
    });
  
    smartCollectionsAddToCartObserver.observe(container, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
  
  // Initialize watching on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchSmartCollectionsAddToCart, { once: true });
  } else {
    watchSmartCollectionsAddToCart();
  }

// ==== SMART COLLECTIONS – MIRROR BACK-IN-STOCK OVERLAY (get overlay from original card and append to rebuy card) ====

function getHandleFromHref(href) {
    try {
      const url = new URL(href, window.location.origin);
      const qs = new URLSearchParams(url.search);
      if (qs.get('_rdiscovery-handle')) return qs.get('_rdiscovery-handle');
      const parts = url.pathname.split('/');
      const i = parts.indexOf('products');
      if (i > -1 && parts[i + 1]) return parts[i + 1];
    } catch (e) {}
    return null;
  }
  
  function findOriginalCard(handle) {
    if (!handle) return null;
    const root = document.querySelector('.shopify-section--main-collection .collection__results');
    if (!root) return null;
  
    // Prefer <product-card handle="...">
    let card = root.querySelector(`product-card[handle="${CSS.escape(handle)}"]`);
    if (card) return card;
  
    // Fallback by link containing /products/<handle>
    const link = root.querySelector(`a[href*="/products/${CSS.escape(handle)}"]`);
    return link ? link.closest('product-card, .product-card') : null;
  }
  
  let bisSyncing = false; // reentry lock - prevent infinite loops
  
  function mirrorBackInStockOverlays() {
    if (bisSyncing) return;        // avoid reentry if mutations fire again
    bisSyncing = true;
    try {
      const rebuyCards = document.querySelectorAll('.rebuy-smart-collections__product');
      if (!rebuyCards.length) return;
  
      rebuyCards.forEach(card => {
        const media =
          card.querySelector('.rebuy-smart-collections__product-media') ||
          card.querySelector('.rebuy-product-media');
        const link =
          card.querySelector('.rebuy-smart-collections__product-media[href], .rebuy-product-media[href], a.rebuy-product-media[href]');
        if (!media || !link) return;
  
        const handle = getHandleFromHref(link.getAttribute('href'));
        const original = findOriginalCard(handle);
        const sourceOverlay = original?.querySelector('.back-in-stock-overlay');
  
        const existing = media.querySelector('.rebuy-bis-overlay');
  
        if (!sourceOverlay) {
          // Only remove if it exists
          if (existing) existing.remove();
          card.classList.remove('has-bis');
          return;
        }
  
        if (!existing) {
          // First-time clone
          const clone = sourceOverlay.cloneNode(true);
          clone.classList.add('rebuy-bis-overlay');
          if (getComputedStyle(media).position === 'static') {
            media.style.position = 'relative';
          }
          media.appendChild(clone);
          card.classList.add('has-bis');
        } else {
          // Update only if content changed (prevents churn)
          const srcHTML = sourceOverlay.innerHTML.trim();
          if (existing.innerHTML.trim() !== srcHTML) {
            existing.innerHTML = srcHTML;
          }
          card.classList.add('has-bis');
        }
      });
    } finally {
      bisSyncing = false;
    }
  }
  
  // Debounced watcher (same pattern as the sorting logic)
  let smartCollectionsBISObserver = null;
  const debouncedMirrorBIS = debounce(mirrorBackInStockOverlays, 120);
  
  function watchSmartCollectionsBIS() {
    const container = document.querySelector('.rebuy-smart-collections__container');
    const originalRoot = document.querySelector('.shopify-section--main-collection .collection__results');
  
    // Wait until both sides exist
    if (!container || !originalRoot) {
      setTimeout(watchSmartCollectionsBIS, 300);
      return;
    }
  
    // Initial pass
    mirrorBackInStockOverlays();
  
    if (smartCollectionsBISObserver) return;
  
    smartCollectionsBISObserver = new MutationObserver((mutations) => {
      // If *all* added/removed nodes are our own .rebuy-bis-overlay, ignore
      const onlyOurOverlays = mutations.every(m => {
        const added = Array.from(m.addedNodes || []).every(n => n.nodeType !== 1 || n.classList?.contains('rebuy-bis-overlay'));
        const removed = Array.from(m.removedNodes || []).every(n => n.nodeType !== 1 || n.classList?.contains('rebuy-bis-overlay'));
        return added && removed;
      });
      if (onlyOurOverlays) return;
  
      debouncedMirrorBIS();
    });
  
    smartCollectionsBISObserver.observe(container, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
  
  // Start watching
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchSmartCollectionsBIS, { once: true });
  } else {
    watchSmartCollectionsBIS();
  }

// ==== SMART CART – CROSS-SELL-WIDGET TRANSLATED ================================

  document.addEventListener('rebuy:smartcart.ready', (e) => {
    const currentLocale = lang; // checked at the top of the script
    
    // Only translate if not default (Rebuy is in English)
    if (currentLocale !== 'en') {
        setTimeout(() => {
            // Find all cross-sell widgets in the smart cart
            const widgets = document.querySelectorAll('[data-rebuy-component="cross-sell-widget"]');
            widgets.forEach(widget => {
                // Find all product blocks in this widget
                const productBlocks = widget.querySelectorAll('.rebuy-product-block');
                productBlocks.forEach(block => {
                    // Extract handle from the class list
                    // Classes look like: "rebuy-product-block koeleskabskasse-medium product-id-..."
                    const classList = block.className.split(' ');
                    const handle = classList[1]; // The handle is the second class
                    if (handle) {
                        let path;
                        if (currentLocale === 'de') {
                            path = `/de/products/${handle}.js`;
                        } else {
                            path = `/products/${handle}.js`;
                        }
                          fetch(path)
                            .then(response => response.json())
                            .then(productData => {
                                if (productData.title) {
                                    // Find the title link within this specific product block
                                    const titleLink = block.querySelector('.rebuy-product-title-link');
                                    
                                    if (titleLink) {
                                        titleLink.textContent = productData.title;
                                    } else {
                                        console.warn(`No title link found for ${handle}`);
                                    }
                                }
                            })
                            .catch(error => {
                                console.error(`Error fetching ${handle}:`, error);
                            });
                    }
                });
            });
        }, 500);
    }
  });
  
// ==== REBUY PRODUCT CARDS – ACCESSIBLE DANISH LABELS ========================

  function translateRebuyProductCards(root = document) {
    const cards = [];

    if (root instanceof Element && root.matches('.rebuy-product-block')) {
      cards.push(root);
    }

    if (root.querySelectorAll) {
      cards.push(...root.querySelectorAll('.rebuy-product-block'));
    }

    cards.forEach(card => {
      const titleLink = card.querySelector('.rebuy-product-title-link');
      const title = (titleLink?.textContent || '').trim();
      if (!title) return;

      card.setAttribute('aria-label', lang === 'dk' ? 'Produkt' : lang === 'de' ? 'Produkt' : 'Product');

      if (titleLink) {
        titleLink.setAttribute('aria-label', fmt(t.view_product, { title }));
      }

      card.querySelectorAll('.rebuy-money .sr-only').forEach(label => {
        const price = label.closest('.rebuy-money');
        const next = price?.classList.contains('sale')
          ? t.sale_price
          : price?.classList.contains('compare-at')
            ? t.original_price
            : t.regular_price;

        if (next && label.textContent.trim() !== next) {
          label.textContent = next;
        }
      });

      const button = card.querySelector('.rebuy-product-actions button, button.rebuy-button');
      if (!button) return;

      button.setAttribute('aria-label', fmt(t.add_product_to_cart, { title }));

      const label = button.querySelector('span');
      if (!label) return;

      const current = label.textContent.trim().toLowerCase();
      if (/sold out|udsolgt|ausverkauft/.test(current)) {
        label.textContent = t.sold_out;
      } else if (/adding|tilføjer|hinzufüg/.test(current)) {
        label.textContent = t.adding_to_cart;
      } else if (/added|tilføjet|hinzugefügt/.test(current)) {
        label.textContent = t.added_to_cart;
      } else if (/add|føj|tilføj|hinzufügen/.test(current) && label.textContent.trim() !== t.add_to_cart) {
        label.textContent = t.add_to_cart;
      }
    });
  }

  let rebuyProductCardObserver = null;
  function watchRebuyProductCards() {
    translateRebuyProductCards();

    if (rebuyProductCardObserver || !document.body) return;

    rebuyProductCardObserver = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (!(node instanceof Element)) return;
          if (node.matches('.rebuy-product-block') || node.querySelector('.rebuy-product-block')) {
            translateRebuyProductCards(node);
          }
        });
      });
    });

    rebuyProductCardObserver.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('rebuy:smartcart.ready', () => {
    requestAnimationFrame(() => translateRebuyProductCards());
  });

  document.addEventListener('rebuy:cart.change', () => {
    requestAnimationFrame(() => translateRebuyProductCards());
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchRebuyProductCards, { once: true });
  } else {
    watchRebuyProductCards();
  }

  setTimeout(() => translateRebuyProductCards(), 500);
  setTimeout(() => translateRebuyProductCards(), 1500);

  // clean up observers on unload to avoid leaks if the theme navigates without reloads
  window.addEventListener('beforeunload', () => {
    sortObserver?.disconnect();
    filterFlyoutObserver?.disconnect();
    titleObserver?.disconnect();
    addToCartObserver?.disconnect();
    quickViewObserver?.disconnect();
    debouncedTranslateMatchingTitles.cancel?.();
    debouncedTranslateAddToCart.cancel?.();
    debouncedTranslateNoResults.cancel?.();
    smartCollectionsObserver?.disconnect();
    smartCollectionsSortObserver?.disconnect();
    smartCollectionsAddToCartObserver?.disconnect();
    rebuyProductCardObserver?.disconnect();
  });